module.exports = __webpack_public_path__ + "img/1468683643.78c60f10.jpg";